var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnimateZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-355.000000, -3762.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-animate-zoom-in",
    transform: "translate(355.000000, 3762.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.97060204e-13,10.4455556 L-8.97060204e-13,13.5372222 C-8.97060204e-13,13.7931111 0.206888889,14 0.462,14 L3.55444444,14 C3.96666667,14 4.17277778,13.5022222 3.88111111,13.2105556 L0.789444444,10.1188889 C0.497777778,9.82722222 -8.97060204e-13,10.0333333 -8.97060204e-13,10.4455556 Z",
    id: "Path",
    fillRule: "nonzero",
    opacity: 0.600000024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4455556,1.24344979e-14 L13.5372222,1.24344979e-14 C13.7931111,1.24344979e-14 14,0.206888889 14,0.462 L14,3.55444444 C14,3.96666667 13.5022222,4.17277778 13.2105556,3.88111111 L10.1188889,0.789444444 C9.82722222,0.497777778 10.0333333,1.24344979e-14 10.4455556,1.24344979e-14 Z",
    id: "Path",
    fillRule: "nonzero",
    opacity: 0.600000024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4455556,14 L13.5372222,14 C13.7931111,14 14,13.7931111 14,13.538 L14,10.4455556 C14,10.0333333 13.5022222,9.82722222 13.2105556,10.1188889 L10.1188889,13.2105556 C9.82722222,13.5022222 10.0333333,14 10.4455556,14 Z",
    id: "Path",
    fillRule: "nonzero",
    opacity: 0.600000024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.97060204e-13,3.55444444 L-8.97060204e-13,0.462 C-8.97060204e-13,0.206888889 0.206888889,1.24344979e-14 0.462,1.24344979e-14 L3.55444444,1.24344979e-14 C3.96666667,1.24344979e-14 4.17277778,0.497777778 3.88111111,0.789444444 L0.789444444,3.88111111 C0.497777778,4.17277778 -8.97060204e-13,3.96666667 -8.97060204e-13,3.55444444 Z",
    id: "Path",
    fillRule: "nonzero",
    opacity: 0.600000024
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 7,
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnimateZoomIn);
export default __webpack_public_path__ + "static/media/icon-animate-zoom-in.480a78d27c9673ff42c3754be80d4805.svg";
export { ForwardRef as ReactComponent };